import React from 'react'
import TreatmentImage from './TreatmentImage'

const Treatment = () => {
  return (
    <>
    <TreatmentImage/>
      
    </>
  )
}

export default Treatment
